import { DialogProvider } from "store";

const withDialogs = (Component) => (props) => (
  <DialogProvider>
    <Component {...props} />
  </DialogProvider>
);

export default withDialogs;
